import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedGPA4to5 from "./SharedGPA4to5";
import SharedGPA5to4 from "./SharedGPA5to4";
const TITLE = "Conversion et calcul de GPA de 4 à 5 et vice versa";
const DESCRIPTION =
  "Conversion et calcul de GPA de 4 à 5 et vice versa pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "conversion et calcul de gpa de 4 à 5 et vice versa, calculatrice conversion et calcul de gpa de 4 à 5 et vice versa, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gpa4to5";
function GPA4() {
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <p>
                  Cette calculatrice vous offre la possibilité de convertir et calculer la moyenne cumulative de 4 à 5 
                  points ou de convertir la moyenne de 5 à 4 facilement et avec précision. Si vous êtes étudiant universitaire 
                  ou diplômé et vous avez besoin d'équivaloir votre moyenne cumulative (GPA) pour postuler à une université, 
                  une bourse d'études ou un emploi, vous pouvez utiliser cet outil pour calculer votre moyenne rapidement 
                  et sans erreurs.
                </p>

                <p>
                  Cette calculatrice GPA vous aide à connaître la méthode de calcul de la moyenne de 4 à 5 et vice versa 
                  en utilisant la formule approuvée, où vous multipliez ou divisez la moyenne selon le système d'évaluation 
                  utilisé dans votre université. Vous pouvez également vérifier la correction de la conversion de votre 
                  moyenne cumulative avant de soumettre vos documents officiels.
                </p>

                <p>
                  Que vous cherchiez à convertir un GPA de 4,0 à 5,0 ou que vous désiriez calculer la moyenne cumulative 
                  inversement, cet outil vous fournit la solution la plus rapide et la plus précise en entrant votre moyenne 
                  actuelle et en obtenant le résultat immédiatement.
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col">
                <SharedGPA4to5 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <div className="col">
                <SharedGPA5to4 />
              </div>
            </div>
            <div>
              <br />
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE} </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Tableau de conversion GPA de 4 à 5 et vice versa{" "}
                    </h2>{" "}
                  </u>
                  <table >
                    <tbody>
                      <tr className="gpa-header">
                        <th>Échelle 4.0</th>
                        <th>Échelle 5.0</th>
                      </tr>
                      <tr>
                        <td>3.97 ~ 4.0</td>
                        <td>4.95 ~ 5.00</td>
                      </tr>
                      <tr>
                        <td>3.92 ~ 3.96</td>
                        <td>4.90 ~ 4.94</td>
                      </tr>
                      <tr>
                        <td>3.88 ~ 3.91</td>
                        <td>4.84 ~ 4.89</td>
                      </tr>
                      <tr>
                        <td>3.84 ~ 3.87</td>
                        <td>4.79 ~ 4.83</td>
                      </tr>
                      <tr>
                        <td>3.80 ~ 3.83</td>
                        <td>4.73 ~ 4.78</td>
                      </tr>
                      <tr>
                        <td>3.75 ~ 3.79</td>
                        <td>4.68 ~ 4.72</td>
                      </tr>
                      <tr>
                        <td>3.71 ~ 3.74</td>
                        <td>4.62 ~ 4.67</td>
                      </tr>
                      <tr>
                        <td>3.67 ~ 3.70</td>
                        <td>4.57 ~ 4.61</td>
                      </tr>
                      <tr>
                        <td>3.62 ~ 3.66</td>
                        <td>4.51 ~ 4.56</td>
                      </tr>
                      <tr>
                        <td>3.58 ~ 3.61</td>
                        <td>4.45 ~ 4.50</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default GPA4;
